import { render, staticRenderFns } from "./CustomerColumnItem.vue?vue&type=template&id=4d31a336&"
import script from "./CustomerColumnItem.vue?vue&type=script&lang=ts&"
export * from "./CustomerColumnItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports